(() => {
  function initGuardionPolicyMenus() {
    const shells = document.querySelectorAll(
      '[data-guardion-policy-shell], [data-guardion-policy]'
    );

    shells.forEach((shell) => {
      if (shell.dataset.menuReady === 'true') return;

      const drawer = shell.querySelector('[data-guardion-menu]');
      const panel = drawer?.querySelector(
        '.guardion-menu-drawer__panel'
      );
      const openButton = shell.querySelector(
        '[data-guardion-menu-open]'
      );
      const closeButtons = Array.from(
        shell.querySelectorAll('[data-guardion-menu-close]')
      );
      const firstFocus = shell.querySelector(
        '[data-guardion-menu-first-focus]'
      );

      if (!drawer || !panel || !openButton) return;

      shell.dataset.menuReady = 'true';

      let previousFocus = null;

      const getFocusable = () =>
        Array.from(
          panel.querySelectorAll(
            'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        );

      function openMenu() {
        previousFocus = document.activeElement;

        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('guardion-menu-is-open');

        window.requestAnimationFrame(() => {
          firstFocus?.focus();
        });
      }

      function closeMenu() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('guardion-menu-is-open');

        if (previousFocus instanceof HTMLElement) {
          previousFocus.focus();
        }
      }

      function trapFocus(event) {
        if (
          event.key !== 'Tab' ||
          !drawer.classList.contains('is-open')
        ) {
          return;
        }

        const focusable = getFocusable();

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (
          event.shiftKey &&
          document.activeElement === first
        ) {
          event.preventDefault();
          last.focus();
        } else if (
          !event.shiftKey &&
          document.activeElement === last
        ) {
          event.preventDefault();
          first.focus();
        }
      }

      openButton.addEventListener('click', openMenu);

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeMenu);
      });

      drawer.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMenu);
      });

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          drawer.classList.contains('is-open')
        ) {
          closeMenu();
          return;
        }

        trapFocus(event);
      });
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    initGuardionPolicyMenus
  );

  document.addEventListener(
    'shopify:section:load',
    initGuardionPolicyMenus
  );
})();